export interface JobCreateRecurring {
  jobTypeId: number;
  name: string;
  includeAllBenchmarks: boolean;
  benchmarkIds: Array<string>;
  jobFrequencyId: number;
  hour: number;
  minute: number;
  timeZoneId: string;
  numberOfQuartersBack: number;
  dayOfTheWeek?: number;
  dayOfMonth?: number;
  isEndOfMonth?: boolean;
}

export interface JobCreateImmediate {
  jobTypeId: number;
  name: string | null;
  includeAllBenchmarks: boolean;
  benchmarkIds: Array<string>;
  specificStartDate: string;
  specificEndDate: string;
}

export enum JobType {
  Immediate = 1,
  Recurring = 2,
}

export enum JobFrequency {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
}

export enum DayOfMonth {
  EndOfMonth = -1,
}
